import React, { useState, useEffect } from "react";
import worldIcon from '../../../assets/images&icons/wsg.svg';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Appstore, setSideMenuIsOpen } from "../../../redux";

interface MenuItem {
  name: string;
  to?: string;
  hasSubmenu?: boolean;
  children?: MenuItem[];
}

const menuItems: MenuItem[] = [
  { name: "About Us", to: "/aboutus" },
  { name: "Members", to: "/wsg_members.asp" },
  { name: "Groups", to: "/wsg_groups.asp" },
  { name: "Events", to: "/events" },
  {
    name: "Insights",
    hasSubmenu: true,
    children: [
      { name: "GC Insights", to: "/gcinsights.asp" },
      { name: "Blog Posts", to: "/blog" },
      { name: "Featured", to: "/blog/featuredblog.aspx" },
      { name: "WSG Blog", to: "/blog/default.aspx" },
    ],
  },
  {
    name: "Resources",
    hasSubmenu: true,
    children: [
      {
        name: "News & Articles",
        hasSubmenu: true,
        children: [
          { name: "Articles", to: "/publications.asp" },
          { name: "Press", to: "/releases.asp" },
          { name: "WSG Collaborations", to: "/success_stories.asp" },
          { name: "WSG Newsletter", to: "/networkwire_1q2026.asp" },
          { name: "Latest World News", to: "/newsfeeds" },
        ]
      },
      { name: "WSG Knowledge Center", to: "/wsg-knowledge-center.asp" },
      { name: "Secondments", to: "/secondments.asp" },
      { name: "Dealmakers", to: "/dealmaker.asp" },
      { name: "Help Center", to: "/help-center" },
    ],
  },
  {
    name: "WSG Learning Institute",
    hasSubmenu: true,
    children: [
      { name: "WSG Leadership Training Program", to: "/wsglearninginstitute_growthplay.asp" },
      { name: "WSG Marketing Workshop", to: "/marketing-workshop-chamber-strategy" },
      { name: "WSG and Emeritus Program", to: "/wsglearninginstituteoverview.asp" },
    ],
  },
];

const sidemenuStyles = `
  .landing-sidemenu {
    position: fixed;
    left: 100%;
    top: 0;
    bottom: 0;
    z-index: 1010;
    width: 100%;
    max-width: 80%;
    font-weight: 500;
    font-family: 'Decimal', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    opacity: 0;
    visibility: hidden;
    transition: all 0.6s ease;
    will-change: transform;
  }
  
  @media (min-width: 1200px) {
    .landing-sidemenu {
      max-width: 67%;
    }
  }
  
  .landing-sidemenu.menu-active {
    visibility: visible;
    opacity: 1;
    transform: translateX(-100%);
  }

  .landing-sidemenu-body {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;
    color: #fff;
    margin-left: auto;
    background-color: #bc3323;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    text-align: left;
  }
  
  @media (min-width: 992px) {
    .landing-sidemenu-body {
      flex-direction: row;
      overflow: hidden;
    }
  }

  .landing-menu-close-button {
    position: absolute;
    top: 30px;
    right: 26px;
    border: none;
    padding: 0;
    z-index: 999;
    width: 36px;
    height: 30px;
    cursor: pointer;
    background: none;
    outline: none;
    margin: 0;
    -webkit-appearance: none;
  }
  
  @media (min-width: 992px) {
    .landing-menu-close-button {
      top: 30px;
      right: 30px;
      width: 40px;
      height: 40px;
    }
  }
  
  @media (min-width: 1600px) {
    .landing-menu-close-button {
      top: 40px;
      right: 70px;
      width: 46px;
      height: 40px;
    }
  }

  .landing-close-bar {
    position: absolute;
    top: 50%;
    display: block;
    width: 100%;
    height: 5px;
    background-color: #fff;
    transform-origin: center center;
    transition: transform 0.35s ease;
  }
  
  .landing-close-bar-left {
    transform: rotate(45deg);
  }
  
  .landing-close-bar-right {
    transform: rotate(-45deg);
  }
  
  .landing-menu-close-button:hover .landing-close-bar-left,
  .landing-menu-close-button:hover .landing-close-bar-right {
    transform: rotate(0deg);
  }

  .landing-sidemenu-left {
    position: relative;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-align: left;
  }
  
  @media (min-width: 992px) {
    .landing-sidemenu-left {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      min-height: 100%;
      background-image: url(https://members-staging.worldservicesgroup.com/assets/images/pattern-dots-red.png);
      background-repeat: repeat;
      background-position: bottom left;
      padding-bottom: 40px;
    }
  }

  .landing-sidemenu-top {
    position: relative;
    padding: 90px 30px 40px 30px;
    background-color: #bc3323;
    text-align: left;
  }
  
  @media (min-width: 992px) {
    .landing-sidemenu-top {
      padding-top: 110px;
    }
  }
  
  @media (min-width: 1600px) {
    .landing-sidemenu-top {
      padding: 130px 70px 60px 70px;
    }
  }

  .landing-menu-link {
    display: none;
    align-items: center;
    position: absolute !important;
    left: 30px;
    top: 50px;
    font-weight: 500;
    color: #87291d;
    font-size: 13px;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
  }
  
  .landing-menu-link.visible {
    display: flex;
  }
  
  @media (min-width: 768px) {
    .landing-menu-link {
      font-size: 15px;
    }
  }
  
  @media (min-width: 992px) {
    .landing-menu-link {
      top: 58px;
      letter-spacing: 0.05em;
      font-size: 16px;
    }
  }
  
  @media (min-width: 1600px) {
    .landing-menu-link {
      left: 70px;
      top: 62px;
      font-size: 22px;
    }
  }

  .landing-main-nav {
    position: relative;
    margin-bottom: 20px;
    overflow: hidden;
    text-align: left;
  }
  
  @media (min-width: 992px) {
    .landing-main-nav {
      margin-bottom: 40px;
    }
  }
  
  @media (min-width: 1600px) {
    .landing-main-nav {
      margin-bottom: 60px;
    }
  }

  .landing-menu-wrapper {
    position: relative;
    display: flex;
    transition: transform 0.4s ease;
    text-align: left;
  }
  
  .landing-menu-wrapper.submenu-open {
    transform: translateX(-100%);
  }

  .landing-menu {
    position: relative;
    line-height: 1.2;
    padding: 0;
    padding-bottom: 6px;
    margin: 0;
    list-style: none;
    font-size: 20px;
    font-weight: 500;
    flex: 0 0 100%;
    width: 100%;
    text-align: left;
  }
  
  @media (min-width: 768px) {
    .landing-menu {
      font-size: 28px;
    }
  }
  
  @media (min-width: 1200px) {
    .landing-menu {
      font-size: 30px;
    }
  }
  
  @media (min-width: 1600px) {
    .landing-menu {
      font-size: 44px;
    }
  }

  .landing-submenu-panel {
    position: relative;
    flex: 0 0 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: 16px;
    font-family: 'Decimal', sans-serif;
    font-weight: 500;
    text-align: left;
  }
  
  @media (min-width: 768px) {
    .landing-submenu-panel {
      font-size: 24px;
    }
  }
  
  @media (min-width: 1600px) {
    .landing-submenu-panel {
      font-size: 30px;
    }
  }
  
  .landing-submenu-panel li {
    margin-bottom: 14px;
    text-align: left;
  }
  
  .landing-submenu-panel .landing-menu-title {
    font-weight: 500;
    margin-bottom: 24px;
    opacity: 1;
    font-size: inherit;
    text-transform: none;
    letter-spacing: normal;
  }

  .landing-menu > li {
    padding: 0;
    margin: 0;
    text-align: left;
  }
  
  .landing-menu > li:not(:last-child) {
    margin-bottom: 18px;
  }

  .landing-menu a,
  .landing-menu button,
  .landing-submenu-panel a,
  .landing-submenu-panel button {
    position: relative;
    color: inherit;
    text-decoration: none;
    transition: opacity 0.35s ease;
    display: inline-block;
  }
  
  .landing-menu a::after,
  .landing-submenu-panel a::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background-color: #fff;
    z-index: 1;
    transform-origin: right center;
    transform: scaleX(0);
    transition: transform 0.4s ease-out;
  }
  
  .landing-menu a:hover::after,
  .landing-submenu-panel a:hover::after {
    transform-origin: left center;
    transform: scaleX(1);
  }
  
  .landing-menu button:hover,
  .landing-submenu-panel button:hover {
    opacity: 1;
  }

  .landing-menu-item-has-children > button {
    position: relative;
    padding: 0;
    background: none;
    border: none;
    color: inherit;
    font: inherit;
    cursor: pointer;
    text-align: left;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .landing-submenu-text {
    position: relative;
    display: inline-block;
  }

  .landing-submenu-text::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background-color: #fff;
    z-index: 1;
    transform-origin: right center;
    transform: scaleX(0);
    transition: transform 0.4s ease-out;
  }

  .landing-menu-item-has-children > button:hover .landing-submenu-text::after {
    transform-origin: left center;
    transform: scaleX(1);
  }
  
  .landing-menu-item-has-children > button::after {
    display: none;
  }
  
  .landing-menu-item-has-children > button::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 8px solid #fff;
  }

  .landing-menu-title {
    font-weight: 500;
    margin-bottom: 15px;
    opacity: 0.6;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .landing-menu-dots {
    max-width: 80px;
    margin-top: 20px;
    display: block;
    opacity: 0.5;
  }
  
  @media (min-width: 992px) {
    .landing-menu-dots {
      margin-top: 30px;
    }
  }

  .landing-sidemenu-right {
    position: relative;
    padding: 60px 30px;
    flex: 0 0 auto;
    width: 100%;
    background-color: #9c3325;
    background-image: url(https://members-staging.worldservicesgroup.com/assets/images/menu-bg.png);
    background-position: right -50px center;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  
  @media (min-width: 992px) {
    .landing-sidemenu-right {
      width: 320px;
      flex: 0 0 320px;
      padding: 110px 35px 40px 35px;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      min-height: 100%;
    }
  }
  
  @media (min-width: 1200px) {
    .landing-sidemenu-right {
      width: 380px;
      flex: 0 0 380px;
      padding: 110px 40px 40px 40px;
    }
  }
  
  @media (min-width: 1600px) {
    .landing-sidemenu-right {
      width: 460px;
      flex: 0 0 460px;
      padding: 130px 70px 60px 70px;
    }
  }

  .landing-sidesearch {
    position: relative;
    margin-bottom: 50px;
  }
  
  @media (min-width: 768px) {
    .landing-sidesearch {
      margin-bottom: 60px;
    }
  }
  
  .landing-sidesearch form {
    margin-bottom: 0;
    display: flex;
    background: #fff;
  }
  
  .landing-sidesearch input[type="search"] {
    flex: 1;
    min-width: 0;
    padding: 14px 12px 14px 16px;
    border: none;
    outline: none;
    font-size: 16px;
    background-color: transparent;
    color: #333;
  }
  
  .landing-sidesearch button {
    width: 48px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    border-left: 1px solid #ddd;
    cursor: pointer;
    color: #bc3323;
    font-size: 18px;
  }

  .landing-top-links {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    margin: 0 0 40px;
    list-style: none;
    font-size: 14px;
    line-height: 1.5;
    text-transform: uppercase;
  }
  
  @media (min-width: 1600px) {
    .landing-top-links {
      margin-bottom: 60px;
      font-size: 18px;
    }
  }
  
  .landing-top-links li {
    padding-left: 0;
    margin-bottom: 0;
  }
  
  .landing-top-links a {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff;
    text-decoration: none;
    transition: opacity 0.3s;
    font-weight: 500;
  }
  
  .landing-top-links a:hover {
    opacity: 0.8;
  }

  .landing-socials {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .landing-social {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    font-weight: 500;
    font-size: 24px;
    line-height: 1;
    border-radius: 50%;
    color: #fff;
    background-color: #bc3323;
    transition: all 0.4s ease;
    text-decoration: none;
  }
  
  @media (min-width: 1200px) {
    .landing-social {
      width: 64px;
      height: 64px;
      font-size: 28px;
    }
  }
  
  @media (min-width: 1600px) {
    .landing-social {
      width: 80px;
      height: 80px;
      font-size: 36px;
    }
  }
  
  .landing-social:hover {
    background-color: #882619;
  }
  
  .landing-social svg {
    width: 0.9em;
    height: 0.9em;
    fill: currentColor;
  }

  .landing-nav-down-button {
    display: inline-flex;
    font-weight: 700;
    font-size: 13px;
    line-height: 1;
    padding: 8px 4px;
    color: #882619 !important;
    text-decoration: none;
  }
  
  @media (min-width: 992px) {
    .landing-nav-down-button {
      display: none;
    }
  }
`;

const LandingMenu: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOpen = useSelector((state: Appstore) => state.menus.sideMenuIsOpen);
  const [activeSubmenu, setActiveSubmenu] = useState<MenuItem | null>(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const styleId = 'landing-sidemenu-styles';
    if (!document.getElementById(styleId)) {
      const styleSheet = document.createElement('style');
      styleSheet.id = styleId;
      styleSheet.textContent = sidemenuStyles;
      document.head.appendChild(styleSheet);
    }
    return () => {
      const existingStyle = document.getElementById(styleId);
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        closeMenu();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setActiveSubmenu(null);
      setSearchTerm("");
    }
  }, [isOpen]);

  const closeMenu = () => {
    dispatch(setSideMenuIsOpen(false));
    setActiveSubmenu(null);
    setSearchTerm("");
  };

  const openSubmenu = (item: MenuItem) => {
    setActiveSubmenu(item);
  };

  const goBack = () => {
    setActiveSubmenu(null);
  };

  const renderSubmenuItem = (item: MenuItem): React.ReactNode => {
    if (item.hasSubmenu && item.children) {
      return (
        <li key={item.name} className="landing-menu-item-has-children">
          <button
            onClick={() => openSubmenu(item)}
          >
            <span className="landing-submenu-text">{item.name}</span>
            <svg
              style={{ width: '1em', height: '1em', marginLeft: '-1px', verticalAlign: 'middle', fill: 'currentColor' }}
              viewBox="0 0 32 32"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M13 7c-.3 0-.6.2-.7.5-.1.3 0 .6.2.8L20.2 16l-7.7 7.7c-.3.3-.3.7 0 1 .3.3.7.3 1 0l8.2-8.2c.3-.3.3-.7 0-1l-8.2-8.2c-.1-.1-.3-.2-.5-.2z" />
            </svg>
          </button>
        </li>
      );
    }

    // Special rendering for JOIN menu item
    if (item.name === 'JOIN') {
      return (
        <li key={item.name}>
          <Link to={item.to || "#"} onClick={closeMenu} style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={worldIcon}
              alt="World"
              style={{ width: '40px', height: '40px', objectFit: 'contain', display: 'inline-block', verticalAlign: 'middle', filter: 'invert(1) brightness(2)' }}
            />
            <span style={{ marginLeft: '14px' }}>{item.name}</span>
          </Link>
        </li>
      );
    }
    return (
      <li key={item.name}>
        <Link to={item.to || "#"} onClick={closeMenu}>
          {item.name}
        </Link>
      </li>
    );
  };

  return (
    <>
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1005,
          }}
          onClick={closeMenu}
        />
      )}

      <div className={`landing-sidemenu ${isOpen ? 'menu-active' : ''}`}>
        <div className="landing-sidemenu-body">

          <button
            className="landing-menu-close-button"
            onClick={closeMenu}
            title="Close(ESC)"
          >
            <span className="landing-close-bar landing-close-bar-left"></span>
            <span className="landing-close-bar landing-close-bar-right"></span>
          </button>

          <div className="landing-sidemenu-left">
            <div className="landing-sidemenu-top">

              <button
                className={`landing-menu-link ${activeSubmenu ? 'visible' : ''}`}
                onClick={goBack}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                <svg
                  style={{ width: '0.8em', height: '0.8em', marginRight: '6px', fill: 'currentColor' }}
                  viewBox="0 0 24 24"
                >
                  <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
                </svg>
                return to <span style={{ fontWeight: 600, marginLeft: '4px' }}>Full Menu</span>
              </button>

              <nav className="landing-main-nav">
                <div className={`landing-menu-wrapper ${activeSubmenu ? 'submenu-open' : ''}`}>
                  <ul className="landing-menu">
                    {menuItems.map(item => renderSubmenuItem(item))}
                  </ul>

                  <ul className="landing-submenu-panel">
                    {activeSubmenu && (
                      <>
                        <li className="landing-menu-title">{activeSubmenu.name}</li>
                        {activeSubmenu.children?.map(child => renderSubmenuItem(child))}
                      </>
                    )}
                  </ul>
                </div>
              </nav>

              <a href="#" className="landing-nav-down-button" onClick={(e) => e.preventDefault()}>
                <svg style={{ width: '1em', height: '1em', fill: 'currentColor' }} viewBox="0 0 24 24">
                  <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                </svg>
              </a>

              <img
                src="https://members-staging.worldservicesgroup.com/assets/images/menu-dots.png"
                alt="dots"
                className="landing-menu-dots"
              />
            </div>
          </div>

          <div className="landing-sidemenu-right">

            <div className="landing-sidesearch">
              <form onSubmit={(e) => {
                e.preventDefault();
                if (!searchTerm.trim()) {
                  return;
                }
                const params = new URLSearchParams({
                  cx: '011122071144402964893:bhcmntz16ky',
                  cof: 'FORID:9',
                  q: searchTerm.trim(),
                  siteurl: window.location.href,
                  ref: '',
                  ss: '',
                });
                closeMenu();
                navigate(`/customsearch.asp?${params.toString()}`);
              }}>
                <input
                  type="search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Enhanced by Google"
                />
                <button type="submit" title="Search">
                  <svg style={{ width: '1.2em', height: '1.2em', fill: 'currentColor' }} viewBox="0 0 24 24">
                    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
                  </svg>
                </button>
              </form>
            </div>

            <ul className="landing-top-links">
              <li>
                <Link to="/contacts.asp" onClick={closeMenu}>
                  <svg style={{ width: '22px', height: '22px', fill: 'currentColor' }} viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                  <span>Contact</span>
                </Link>
              </li>
              <li>
                <Link to="/join" onClick={closeMenu} style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={worldIcon}
                    alt="World"
                    style={{ width: '28px', height: '28px', objectFit: 'contain', display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
                  />
                  <span style={{ marginLeft: 0, fontSize: '1.1em' }}>JOIN</span>
                </Link>
              </li>
            </ul>

            <div className="landing-socials">
              <a
                href="https://www.facebook.com/worldservicesgroup"
                target="_blank"
                rel="noopener noreferrer"
                className="landing-social"
                title="Facebook"
              >
                <svg viewBox="0 0 320 512">
                  <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
                </svg>
              </a>
              <a
                href="https://twitter.com/worldservsgroup"
                target="_blank"
                rel="noopener noreferrer"
                className="landing-social"
                title="Twitter"
              >
                <svg viewBox="0 0 512 512">
                  <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/worldservicesgroup"
                target="_blank"
                rel="noopener noreferrer"
                className="landing-social"
                title="Linkedin"
              >
                <svg viewBox="0 0 448 512">
                  <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingMenu;
